<div class="offers-container">
  <!-- Title Section -->
  <div class="title-section">
    <h3 class="section-title">Offers</h3>
    <button class="edit-btn" (click)="onEditClick()">
      <span class="edit-text">Edit</span>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99935 4.33321L11.666 6.99988M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z" stroke="#1B5BFF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    </button>
  </div>

  <!-- Offers List -->
  <div class="offers-list">
    <div *ngFor="let offer of offers; trackBy: trackByIndex" class="offer-card">
      <!-- Offer Header -->
      <div class="offer-header">
        <div class="offer-title-section">
          <h4 class="offer-name">{{ offer.name }}</h4>
        </div>
        
      </div>
      
      <p class="offer-description">{{ offer.description }}</p>
      
      <!-- Divider -->
      <div class="divider"></div>
      
      <!-- Detailed Offer Information Grid -->
      <div class="offer-details-grid">
        <!-- Row 1 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">OFFER NAME</span>
            <span class="detail-value">{{ offer.name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">PROMO CODE</span>
            <span class="detail-value">{{ offer.promoCode }}</span>
          </div>
        </div>
        
        <!-- Row 2 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">OFFER TYPE</span>
            <span class="detail-value">{{ removeUnderscores(offer.offerType) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">DISCOUNT VALUE</span>
            <span class="detail-value">{{ offer.discountValue }}</span>
          </div>
        </div>
        
        <!-- Row 3 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">CAR WASH TYPE</span>
            <span class="detail-value">{{ removeUnderscores(offer.carWashType) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">LOCATION</span>
            <span class="detail-value" 
                  [title]="getLocationTooltipText()">
              <span *ngFor="let location of campaign.locations; let last = last; trackBy: trackByIndex">
                {{ location.branch }}<span *ngIf="!last">, </span>
              </span>
            </span>
          </div>
        </div>
        
        <!-- Row 4 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">MAXIMUM DISCOUNT AMOUNT</span>
            <span class="detail-value" *ngIf="offer.max_discount !== null && offer.max_discount !== ''">{{ '$' + offer.max_discount  }}</span>
            <span class="detail-value" *ngIf="offer.max_discount === null || offer.max_discount === ''">N/A</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">QUANTITY LIMIT</span>
            <span class="detail-value">{{ offer.quantityLimit }}</span>
          </div>
        </div>
        
        <!-- Row 5 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">USAGE</span>
            <span class="detail-value">{{ offer.usage }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">USAGE LIMIT</span>
            <span class="detail-value">{{ offer.usageLimit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="offers.length === 0" class="empty-state">
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm0 40c-8.837 0-16-7.163-16-16s7.163-16 16-16 16 7.163 16 16-7.163 16-16 16z" fill="#E9EAEC"/>
      <path d="M32 20v24M20 32h24" stroke="#A7ABB3" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <h4 class="empty-title">No offers yet</h4>
    <p class="empty-description">Create your first offer to get started with this campaign.</p>
    <button class="create-offer-btn">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1V15M1 8H15" stroke="#1B5BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Create Offer
    </button>
  </div>
</div>
